import React from 'react';
import { Link } from 'react-router-dom';
import ParticlesBG from '../Shared/ParticlesBG';
import '../Assets/Stylesheets/Pages/Resources.scss';

const Resources = () => {
  const resourceCategories = [
    {
      title: 'Blog & News',
      description: 'Stay updated with the latest marketing trends, tips, and industry insights',
      icon: '📰',
      link: '/blog',
      color: '#FE5500'
    },
    {
      title: 'Marketing Guides',
      description: 'Comprehensive guides to help you master digital marketing strategies',
      icon: '📚',
      link: '#guides',
      color: '#FF6300',
      comingSoon: true
    },
    {
      title: 'Video Tutorials',
      description: 'Learn through step-by-step video tutorials and webinars',
      icon: '🎥',
      link: '#videos',
      color: '#FE9700',
      comingSoon: true
    },
    {
      title: 'Templates & Tools',
      description: 'Download free marketing templates, checklists, and resources',
      icon: '🛠️',
      link: '#templates',
      color: '#FFAA01',
      comingSoon: true
    },
    {
      title: 'Case Studies',
      description: 'Real success stories from businesses using TRND solutions',
      icon: '📊',
      link: '#case-studies',
      color: '#FEBF00',
      comingSoon: true
    },
    {
      title: 'Technical Docs',
      description: 'Product guides and technical documentation for TRND tools',
      icon: '📖',
      link: '/resources/technical-docs/campaign-simulator',
      color: '#F8D900'
    }
  ];

  return (
    <div className="resources-page">
      <ParticlesBG />
      
      <div className="resources-hero">
        <div className="container">
          <h6>LEARN & GROW</h6>
          <h1>
            Marketing <span className="gradient-text">Resources</span>
          </h1>
          <p className="subtitle">
            Everything you need to succeed in digital marketing. From expert guides to practical tools,
            we've got the resources to help your business thrive.
          </p>
        </div>
      </div>

      <div className="resources-content">
        <div className="container">
          <div className="resources-grid">
            {resourceCategories.map((category, index) => (
              category.comingSoon ? (
                <div 
                  key={index} 
                  className="resource-card coming-soon"
                  style={{ '--card-color': category.color }}
                >
                  <div className="resource-icon">{category.icon}</div>
                  <h3>{category.title}</h3>
                  <p>{category.description}</p>
                  <span className="coming-soon-badge">Coming Soon</span>
                </div>
              ) : (
                <Link 
                  to={category.link} 
                  key={index} 
                  className="resource-card"
                  style={{ '--card-color': category.color }}
                >
                  <div className="resource-icon">{category.icon}</div>
                  <h3>{category.title}</h3>
                  <p>{category.description}</p>
                  <div className="resource-arrow">→</div>
                </Link>
              )
            ))}
          </div>

          <div className="resources-cta">
            <h2>Need Personalized Help?</h2>
            <p>Our team is here to guide you through your marketing journey</p>
            <div className="cta-buttons">
              <Link to="/contact" className="cta-button primary">
                Contact Us
              </Link>
              <Link to="/marketing-genius" className="cta-button secondary">
                Try Marketing Genius
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Resources;

